import type { BrandliveEvent, EmailSubscriptions, IScheduledEmail, PasscodeListMember, SentScheduledEmailsWithEventName } from '@/types/working-model';
import { Get, Post, PostJson } from './helpers';
import type { AudienceMemberMinimal } from '@/types/audience-list-members.types';

export function GetPasscodeListMembers(
	token: string,
	passcode_list: number,
	offset: number,
	order: number
): Promise<PasscodeListMember[] | AudienceMemberMinimal[]> {
	return Get(
		`/v3/admin/content/passcode-lists/members/${passcode_list}/${offset}/${order}`,
		token
	);
}

export async function SearchMembers(
	token: string,
	passcode_list: number,
	offset: number,
	value: string,
	order: number
): Promise<PasscodeListMember[] | AudienceMemberMinimal[]> {
	if (value === '') {
		return Get(
			`/v3/admin/content/passcode-lists/members/${passcode_list}/${offset}/${order}`,
			token
		);
	} else {
		return Get(
			`/v3/admin/content/passcode-lists/members/${passcode_list}/${offset}/${order}/${encodeURIComponent(value)}`,
			token
		);
	}
}

export function SearchMembersCount(
	token: string,
	list: number,
	value: string
): Promise<any[]> {
	if (value === '') {
		return Get(
			`/v3/admin/content/passcode-lists/members-count/${list}`,
			token
		);
	}
	else {
		return Get(
			`/v3/admin/content/passcode-lists/members-count/${list}/${encodeURIComponent(value)}`,
			token
		);
	}
}

export function AddNewMember(
	token: string,
	list: number | undefined,
	passcode: string,
	email: string,
	firstName: string,
	lastName: string
): Promise<any> {
	if (list) {
		return Post(`/v3/admin/content/passcode-lists/addmember/`, token, {
			list,
			passcode,
			email,
			firstName,
			lastName
		});
	} else { return Promise.resolve(); }
}

export function GetAudienceInviteStatus(token: string, channel: number, passcodeList: number, emails: string[]) {
	return PostJson<
		{ emails: string[] },
		{
			invites: SentScheduledEmailsWithEventName[],
			eventsWithoutInvites: BrandliveEvent[],
			unsubscribedUsers: EmailSubscriptions[],
			pendingInvites: (IScheduledEmail & {
				event_name: string;
			})[]
		}
	>({
		path: `/v3/admin/scheduled-emails/invite-status/${channel}/${passcodeList}`,
		data: { emails }
	});
}

export function GetPostmarkStatus(token: string, channel: number, passcodeList: number, email: string): Promise<{ invites: any[] }> {
	return Post(
		`/v3/admin/scheduled-email/invite-status/${channel}/${passcodeList}`,
		token,
		{ email }
	);
}